import {ALERT_TYPES, DEFAULT_ERROR_MESSAGE, NFMS_ENDPOINT_MAP, NFMS_TARGET_PREFIX, TCP_ROLES_HEADER} from "./Constants";
import {getEmployeeTCPRoles} from "./components/permissions/PermissionContext";

export const getHeadersForNFMS = async (target) => {
    const tcpRole = await getEmployeeTCPRoles();
    return {
        headers: {
            "X-Amz-Target": NFMS_TARGET_PREFIX + target,
            "Content-Encoding": "amz-1.0",
            [TCP_ROLES_HEADER]: tcpRole
        },
    };
}

export function getNodeId() {
    let params = new URLSearchParams(window.location.search);
    return params.get('stationCode');
}

export function getNFMSEndpoint() {
    const endpoint_key = "EUAmazon-gamma";
    console.log("endpoint key " + endpoint_key);
    return NFMS_ENDPOINT_MAP[endpoint_key];
}

export function getErrorAlertObjectFromResponse(response) {
    if (response.data && response.data.message) {
        const message = response.data.message;
        const truncated_message = (message.length > 300) ? message.substr(0, 300) + '...' : message;
        const error_text = "ERROR : " + truncated_message;
        return {visible: true, text: error_text, type: ALERT_TYPES.ERROR};
    }
    return {visible: true, text: DEFAULT_ERROR_MESSAGE, type: ALERT_TYPES.ERROR};
}


// WEBPACK FOOTER //
// ./src/Utils.js